import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import DownloadPDFButton from '../DownloadButton/paperscorer';
import PracticeExamScoringGuideButton from '../PracticeExamScoringGuideButton';
import { SCORING_GUIDE } from 'legacy-src/constants/assessmentResourceTypes';
import {
  assessmentScoringGuideQuery,
  assignmentScoringGuideQuery,
} from '../../../queries';

const ScoringGuideDownloadButton = (props) => {
  const {
    assignmentId,
    assessmentId,
    masterSubjectId,
    isStudent,
    showAttestationFlag,
    associatedResources,
    showIcons = false,
    downloadFreshCopy,
    onDownload,
    label,
    className,
    role,
    onSendTelemetryEvent,
  } = props;

  if (isStudent) {
    return null;
  } // Cannot download Scoring Guide

  const resourceUrl = associatedResources[SCORING_GUIDE];
  if (showAttestationFlag && resourceUrl) {
    return (
      <PracticeExamScoringGuideButton
        role={role}
        className={className}
        label={label}
        associatedResources={associatedResources}
        showIcons={showIcons}
        onSendTelemetryEvent={onSendTelemetryEvent}
      />
    );
  }

  return (
    <DownloadPDFButton
      role={role}
      label={label}
      data-test-download-nonpe-scoring-guide
      query={
        assessmentId ? assessmentScoringGuideQuery : assignmentScoringGuideQuery
      }
      variables={{ assignmentId, assessmentId, masterSubjectId }}
      getURLFromResponse={(resp) =>
        assessmentId
          ? resp.data.assessment.scoringGuideUrl
          : resp.data.assignment.scoringGuideUrl
      }
      btn={{ color: 'gray' }}
      className={cn('popOverOnDown', className)}
      showIcons={showIcons}
      downloadFreshCopy={downloadFreshCopy}
      onDownload={onDownload}
      onSendTelemetryEvent={onSendTelemetryEvent}
    >
      Scoring Guide
    </DownloadPDFButton>
  );
};

ScoringGuideDownloadButton.propTypes = {
  isStudent: PropTypes.bool,
  showAttestationFlag: PropTypes.bool,
  associatedResources: PropTypes.object,
  assignmentId: PropTypes.string,
  assessmentId: PropTypes.string,
  masterSubjectId: PropTypes.string,
  downloadFreshCopy: PropTypes.bool,
  onDownload: PropTypes.func,
  label: PropTypes.any,
  className: PropTypes.string,
  role: PropTypes.string,
};

ScoringGuideDownloadButton.defaultProps = {
  isStudent: false,
  showAttestationFlag: false,
  associatedResources: {},
  assignmentId: '',
  assessmentId: '',
  masterSubjectId: '',
  downloadFreshCopy: false,
  onDownload: () => {},
  label: '',
  className: '',
  role: 'button',
};

export default ScoringGuideDownloadButton;
